import React from 'react'

import { PresetConfigLoader } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/PresetConfigLoader'

import { DocumentTypeInputParametersHierarchyConfigComponentProps } from '../model'

import { useDocumentTypeEffectiveInputParameters } from '../hooks'

import { MeetingTemplateGlobalTemplateConfigFormBody } from './MeetingTemplateGlobalTemplateConfigFormBody'

export const DocumentTypeGlobalTemplateInputParameterConfigForm: React.FC<DocumentTypeInputParametersHierarchyConfigComponentProps> = ({
  type,
  typeId,
  onHide,
  inputParametersSchema,
  defaultInputParameters,
  documentTypeId,
  showCustomizationSetting,
  ipHierarchyEnabled,
}) => {
  const { inputParameters, parentInputParameters, updateLoading, updateInputParameters, isCustomized } = useDocumentTypeEffectiveInputParameters(
    type,
    typeId,
    defaultInputParameters,
    undefined,
    documentTypeId,
  )

  if (!inputParameters || !parentInputParameters) {
    return <PresetConfigLoader />
  }

  return (
    <MeetingTemplateGlobalTemplateConfigFormBody
      type={type}
      typeId={typeId}
      inputParametersSchema={inputParametersSchema}
      inputParameters={{ example_1: '', example_2: '', template: inputParameters.template }}
      defaultInputParameters={{ example_1: '', example_2: '', template: defaultInputParameters?.template ?? '' }}
      parentInputParameters={{ example_1: '', example_2: '', template: parentInputParameters.template }}
      isCustomized={isCustomized}
      showCustomizationSetting={showCustomizationSetting}
      onSave={updateInputParameters}
      onHide={onHide}
      updateLoading={updateLoading}
      ipHierarchyEnabled={ipHierarchyEnabled}
    />
  )
}
